/** Builds a narrow patch that removes every supported node-binding location. */
export function buildShapeUnbindPatch(shape: Record<string, unknown>): Record<string, unknown> {
  const props = { ...((shape.props as Record<string, unknown> | undefined) ?? {}) };
  const attrs = { ...((shape.attrs as Record<string, unknown> | undefined) ?? {}) };
  delete props.dataBinding;
  delete attrs.dataBinding;
  return { dataBinding: undefined, props, attrs };
}
